export type QuoteRoomVisibilityDetail = {
  dsy_cpqfields: {
    _dsy_room_value?: string | null
  }
}

export function getRoomsWithQuoteDetails(quoteDetails: QuoteRoomVisibilityDetail[] | null | undefined) {
  const roomIds = new Set<string>()
  for (const detail of quoteDetails ?? []) {
    const roomId = detail.dsy_cpqfields._dsy_room_value
    if (roomId) roomIds.add(roomId)
  }
  return roomIds
}

export function hasRoomQuoteDetails(quoteDetails: QuoteRoomVisibilityDetail[] | null | undefined) {
  return getRoomsWithQuoteDetails(quoteDetails).size > 0
}

/**
 * Which rooms a room filter admits — the gate temporary (unsaved) rooms and
 * systems are tested against.
 *
 * A leaf filter admits its exact room, as it always has. A parent filter admits
 * the whole room group, so a child room added while the parent filter is active
 * does not vanish from the surface that just created it. `visibleRoomIds` is the
 * resolved group (`useRoomGroupDetails().roomIds`) — pass null/undefined for the
 * exact-room path.
 */
export function isRoomVisibleUnderFilter({
  roomId,
  filterRoomId,
  visibleRoomIds,
}: {
  roomId: string
  filterRoomId?: string | null
  visibleRoomIds?: readonly string[] | null
}) {
  if (!filterRoomId) return true
  if (visibleRoomIds) return visibleRoomIds.includes(roomId)
  return roomId === filterRoomId
}

export function shouldDisableHideEmptyRooms({
  currentRoom,
  quoteDetails,
}: {
  currentRoom?: string | null
  quoteDetails: QuoteRoomVisibilityDetail[] | null | undefined
}) {
  return !!currentRoom || !hasRoomQuoteDetails(quoteDetails)
}

export function shouldHideEmptyRooms({
  currentRoom,
  hideEmptyRooms,
  quoteDetails,
}: {
  currentRoom?: string | null
  hideEmptyRooms: boolean
  quoteDetails: QuoteRoomVisibilityDetail[] | null | undefined
}) {
  return hideEmptyRooms && !shouldDisableHideEmptyRooms({ currentRoom, quoteDetails })
}
